'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ReporterActionTypes = require('./ReporterActionTypes');

var ReporterActionTypes = _interopRequireWildcard(_ReporterActionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var libName = 'react-rhumb';

// TODO unit test
var toDuration = function toDuration(checks, timestamp, markers) {
  var longest = Math.max.apply(Math, _toConsumableArray(markers.filter(function (marker) {
    return Object.prototype.hasOwnProperty.call(checks, marker);
  }).map(function (marker) {
    return checks[marker].timestamp;
  })));

  return Math.max(0, longest - timestamp);
};

var consoleReporter = void 0; // TODO ternary

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production') {
  var Colors = {
    OBSIDIAN: '#33475b',
    OZ: '#00bda5',
    OZ_LIGHT: '#e5f8f6',
    OZ_DARK: '#00a38d',
    CANDY_APPLE_DARK: '#d94c53',
    SLINKY: '#516f90',
    MARIGOLD: '#f5c26b',
    MARIGOLD_LIGHT: '#fef8f0',
    CANDY_APPLE_LIGHT: '#fdedee',
    CANDY_APPLE: '#f2545b',
    THUNDERDOME: '#6a78d1',
    THUNDERDOME_LIGHT: '#f0f1fa'
  };

  var labelCss = function labelCss(backgroud, border) {
    return 'background-color:' + backgroud + ';color:' + Colors.OBSIDIAN + ';padding: 0 .5rem;border-left: 4px solid ' + border + ';';
  };

  var colorCss = function colorCss(val) {
    return 'color:' + val + ';';
  };

  // TODO only console reporter cares
  var toMarkerTimings = function toMarkerTimings(checks, timestamp) {
    return Object.keys(checks).reduce(function (acc, marker) {
      return checks[marker].mounted ? Object.assign(acc, _defineProperty({}, marker, Math.max(0, checks[marker].timestamp - timestamp))) : acc;
    }, {});
  };

  var logMarkerTimings = function logMarkerTimings(routeSpec, markerTimings) {
    var _console;

    console.group('marker timings:');
    var markers = Object.keys(markerTimings).sort(function (a, b) {
      return markerTimings[a] - markerTimings[b];
    });

    // eslint-disable-next-line no-restricted-globals
    var successMarkers = new Set();
    Object.keys(routeSpec.success).forEach(function (scenario) {
      routeSpec.success[scenario].forEach(function (marker) {
        return successMarkers.add(marker);
      });
    });

    var colorForMarker = function colorForMarker(marker) {
      if (successMarkers.has(marker)) {
        return Colors.OZ_DARK;
      } else if (routeSpec.error.includes(marker)) {
        return Colors.CANDY_APPLE_DARK;
      } else {
        return Colors.SLINKY;
      }
    };

    (_console = console).log.apply(_console, [markers.map(function (marker) {
      return '%c' + marker + '%c (' + markerTimings[marker].toFixed(2) + 'ms)';
    }).join('\n')].concat(_toConsumableArray(markers.reduce(function (acc, marker) {
      return [].concat(_toConsumableArray(acc), [colorCss(colorForMarker(marker)), colorCss(Colors.OBSIDIAN)]);
    }, []))));
    console.groupEnd();
  };

  var logMarkerState = function logMarkerState(routeSpec, checks) {
    console.group('expected markers:');
    Object.keys(routeSpec.success).forEach(function (scenario) {
      var _console2;

      (_console2 = console).log.apply(_console2, ['success (' + scenario + '): ' + routeSpec.success[scenario].map(function (marker) {
        return '%c' + marker;
      }).join(', ')].concat(_toConsumableArray(routeSpec.success[scenario].map(function (marker) {
        return colorCss(checks[marker] && checks[marker].mounted ? Colors.OZ_DARK : Colors.SLINKY);
      }))));
    });

    if (routeSpec.error.length) {
      var _console3;

      (_console3 = console).log.apply(_console3, ['error: ' + routeSpec.error.map(function (marker) {
        return '%c' + marker;
      }).join(', ')].concat(_toConsumableArray(routeSpec.error.map(function (marker) {
        return colorCss(checks[marker] && checks[marker].mounted ? Colors.CANDY_APPLE_DARK : Colors.SLINKY);
      }))));
    }
    var others = Object.keys(checks).filter(function (marker) {
      return checks[marker].mounted;
    }).filter(function (marker) {
      return !routeSpec.error.some(function (errorMarker) {
        return errorMarker === marker;
      }) && !Object.keys(routeSpec.success).some(function (scenario) {
        return routeSpec.success[scenario].some(function (successMarker) {
          return successMarker === marker;
        });
      });
    });
    if (others.length) {
      console.log('others: ' + others.join(', '));
    }
    console.groupEnd();
  };

  var resolved = {};
  var someResolved = false;

  consoleReporter = function consoleReporter(action) {
    if (resolved[action.payload.entry.id] && action.type !== ReporterActionTypes.CHECKS_CHANGED) {
      return;
    }

    var _action$payload = action.payload,
        entry = _action$payload.entry,
        routeSpec = _action$payload.routeSpec,
        extra = _action$payload.extra;

    switch (action.type) {
      case ReporterActionTypes.ROUTE_STARTED:
        {
          var checks = entry.checks,
              pathname = entry.pathname;
          var timeout = routeSpec.timeout,
              route = routeSpec.route;


          console.groupCollapsed('%c' + libName + '%c ' + pathname + ' (' + route + ')', labelCss(Colors.MARIGOLD_LIGHT, Colors.MARIGOLD), '');
          console.log('timeout: ' + timeout + 'ms');
          logMarkerState(routeSpec, checks);
          console.groupEnd();

          break;
        }
      case ReporterActionTypes.ROUTE_UNEXPECTED:
        {
          var _pathname = entry.pathname;


          console.groupCollapsed('%c' + libName + '%c ' + _pathname + ' (unexpected)', labelCss(Colors.CANDY_APPLE_LIGHT, Colors.CANDY_APPLE), '');
          console.log('This route should be added to the configuration file.');
          console.groupEnd();

          break;
        }
      case ReporterActionTypes.ROUTE_ABANDONED:
        {
          var _pathname2 = entry.pathname;


          console.groupCollapsed('%c' + libName + '%c ' + _pathname2 + ' (abandoned)', labelCss(Colors.MARIGOLD_LIGHT, Colors.MARIGOLD), '');
          console.groupEnd();

          break;
        }
      case ReporterActionTypes.ROUTE_SUCCEEDED:
        {
          var scenario = extra.scenario;
          var _checks = entry.checks,
              _pathname3 = entry.pathname,
              timestamp = entry.timestamp;


          var duration = toDuration(_checks, timestamp, routeSpec.success[scenario]);
          var markerTimings = toMarkerTimings(_checks, timestamp);

          console.groupCollapsed('%c' + libName + '%c ' + _pathname3 + ' (success)', labelCss(Colors.OZ_LIGHT, Colors.OZ), '');
          console.log('duration: ' + duration.toFixed(2) + 'ms');
          console.log('scenario: ' + scenario);
          logMarkerTimings(routeSpec, markerTimings);
          console.groupEnd();

          break;
        }
      case ReporterActionTypes.ROUTE_FAILED:
        {
          var _checks2 = entry.checks,
              _pathname4 = entry.pathname,
              _timestamp = entry.timestamp;


          var _duration = toDuration(_checks2, _timestamp, routeSpec.error);
          var _markerTimings = toMarkerTimings(_checks2, _timestamp);

          console.groupCollapsed('%c' + libName + '%c ' + _pathname4 + ' (failure)', labelCss(Colors.CANDY_APPLE_LIGHT, Colors.CANDY_APPLE), '');
          console.log('duration: ' + _duration.toFixed(2) + 'ms');
          logMarkerTimings(routeSpec, _markerTimings);
          console.groupEnd();

          break;
        }
      case ReporterActionTypes.ROUTE_TIMEOUT_EXPIRED:
        {
          var _checks3 = entry.checks,
              _pathname5 = entry.pathname,
              _timestamp2 = entry.timestamp,
              expiredTimestamp = entry.expiredTimestamp;

          var _duration2 = expiredTimestamp - _timestamp2;
          var _markerTimings2 = toMarkerTimings(_checks3, _timestamp2);

          console.groupCollapsed('%c' + libName + '%c ' + _pathname5 + ' (timeout)', labelCss(Colors.CANDY_APPLE_LIGHT, Colors.CANDY_APPLE), '');
          console.log('duration: ' + _duration2.toFixed(2) + 'ms');
          logMarkerTimings(routeSpec, _markerTimings2);
          console.groupEnd();

          break;
        }
      case ReporterActionTypes.CHECKS_CHANGED:
        {
          var _checks4 = entry.checks,
              _pathname6 = entry.pathname;


          console.groupCollapsed('%c' + libName + '%c ' + _pathname6 + ' (update)', labelCss(Colors.MARIGOLD_LIGHT, Colors.MARIGOLD), '');
          logMarkerState(routeSpec, _checks4);
          console.groupEnd();

          break;
        }
      default:
    }

    switch (action.type) {
      case ReporterActionTypes.ROUTE_STARTED:
      case ReporterActionTypes.CHECKS_CHANGED:
        break;
      default:
        {
          resolved[action.payload.entry.id] = true;
        }
    }

    switch (action.type) {
      case ReporterActionTypes.ROUTE_TIMEOUT_EXPIRED:
      case ReporterActionTypes.ROUTE_UNEXPECTED:
      case ReporterActionTypes.ROUTE_SUCCEEDED:
      case ReporterActionTypes.ROUTE_FAILED:
        {
          if (!someResolved) {
            var _pathname7 = entry.pathname;

            console.groupCollapsed('%c' + libName + '%c ' + _pathname7 + ' (page tracking finished)', labelCss(Colors.THUNDERDOME_LIGHT, Colors.THUNDERDOME), '');
            console.log('For Reagan compatibility react-rhumb will monitor until the first "finished" (success, failure, timeout) route is seen. Any of the following data that is collected will not be sent to NewRelic or factor into the SLA calculations.');
            console.groupEnd();
            someResolved = true;
          }
          break;
        }
      default:
    }
  };
} else {
  var _resolved = {};

  consoleReporter = function consoleReporter(action) {
    var _action$payload2 = action.payload,
        _action$payload2$entr = _action$payload2.entry,
        pathname = _action$payload2$entr.pathname,
        timestamp = _action$payload2$entr.timestamp,
        expiredTimestamp = _action$payload2$entr.expiredTimestamp,
        checks = _action$payload2$entr.checks,
        id = _action$payload2$entr.id,
        routeSpec = _action$payload2.routeSpec,
        extra = _action$payload2.extra;


    if (_resolved[id] && action.type !== ReporterActionTypes.CHECKS_CHANGED) {
      return;
    }

    var log = function log() {
      var _console4;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_console4 = console).log.apply(_console4, ['[' + libName + ']', pathname].concat(args));
    };
    var formatDuration = function formatDuration(num) {
      return num.toFixed(2) + 'ms';
    };

    switch (action.type) {
      case ReporterActionTypes.ROUTE_STARTED:
        {
          var route = routeSpec.route;

          log('(' + route + ')');
          break;
        }
      case ReporterActionTypes.ROUTE_UNEXPECTED:
        {
          log('(unexpected)');
          break;
        }
      case ReporterActionTypes.ROUTE_ABANDONED:
        {
          log('(abandoned)');
          break;
        }
      case ReporterActionTypes.ROUTE_SUCCEEDED:
        {
          var scenario = extra.scenario;

          var duration = toDuration(checks, timestamp, routeSpec.success[scenario]);
          log('(success) ' + formatDuration(duration));
          break;
        }
      case ReporterActionTypes.ROUTE_FAILED:
        {
          var error = routeSpec.error;

          var _duration3 = toDuration(checks, timestamp, error);
          log('(failure) ' + formatDuration(_duration3));
          break;
        }
      case ReporterActionTypes.ROUTE_TIMEOUT_EXPIRED:
        {
          var _duration4 = expiredTimestamp - timestamp;
          log('(timeout) ' + formatDuration(_duration4));
          break;
        }
      case ReporterActionTypes.CHECKS_CHANGED:
        {
          log('(update)');
          break;
        }
      default:
    }

    switch (action.type) {
      case ReporterActionTypes.ROUTE_STARTED:
      case ReporterActionTypes.CHECKS_CHANGED:
        break;
      default:
        _resolved[id] = true;
    }
  };
}

exports.default = consoleReporter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-rhumb/static-1.2431/js/internal/consoleReporter.js
// module id = 635
// module chunks = 3 4